module.exports = __webpack_public_path__ + "img/register_success.80571bb5.png";